<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <div class="px-3 my-2" v-if="enterprises">
        <el-select v-model="enterprise" placeholder="Select a Business" class="w-100" @change="updateRoute">
          <el-option :value="null" label="Select a Business"></el-option>
          <el-option v-for="enterprise in enterprises" :key="enterprise.id" :value="enterprise.slug" :label="enterprise.name"></el-option>
        </el-select>
      </div>
      <template slot="links">
        <sidebar-item :link="{
            name: 'Back to ClarityNOW',
            icon: 'fas fa-home text-black',
            path: '/home'
          }"
        ></sidebar-item>
        <sidebar-item :link="{
            name: 'Enterprise Dashboard',
            icon: 'fas fa-tachometer-alt text-black',
            path: '/enterprise/dashboard'
          }"
        ></sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <enterprise-navbar :type="$route.meta.navbarType"></enterprise-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import axios from 'axios';
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import EnterpriseNavbar from './EnterpriseNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';
  import { mapGetters } from 'vuex';
  import {Select, Option} from 'element-ui';

  export default {
    components: {
      EnterpriseNavbar,
      ContentFooter,
      FadeTransition,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
        portalRoles: ['owner', 'agent'],
        enterprise: null
      }
    },
    computed: {
      ...mapGetters({
        user: 'profile/user',
        roles: 'roles/roles',
        enterprises: 'profile/enterprises'
      }),
      role() {
        return this.roles[0];
      },
      owner() {
        return this.role == 'owner';
      },
      portalAccess() {
        return this.portalRoles.includes(this.role);
      },
      active() {
        return this.portalAccess && this.user.setup_complete;
      },
      observatory() {
        return this.$route.meta.observatory;
      },
      observatoryPath() {
        return '/observatory/' + this.$route.params.user;
      }
    },
    methods: {
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      },
      checkEnterprise() {
        if (this.$route.params.enterprise) {
          this.enterprise = this.$route.params.enterprise;
        } else {
          this.enterprise = null;
        }
      },
      updateRoute() {
        if (this.enterprise == null) {
          this.$router.push({name: 'Enterprise Dashboard'});
        }
        if (this.$route.params.enterprise && this.$route.params.enterprise !== this.enterprise) {
          this.$router.push({ name: 'Enterprise Settings', params: {enterprise: this.enterprise}});
        }
      }
    },
    mounted() {
      this.initScrollbar()
    },
    created() {
      this.checkEnterprise();
    },
    watch: {
      $route(to, from) {
        this.checkEnterprise();
      }
    }
  };
</script>
<style lang="scss">
</style>
